import { LevelSpec } from '../game/LevelSpec';
import { Fridge } from '../game/objects/Fridge';
import { Direction } from '../game/Direction';
import { Bench } from '../game/objects/Bench';
import { Drink } from '../game/objects/Drink';
import { ServingSpot } from '../game/objects/ServingSpot';
export default new LevelSpec({
    title: 'Going Loopy',
    goal: 'Serve 5 drinks using a loop.',
    testGoal: (world) => {
        if (world.served.filter(obj => obj instanceof Drink).length === 5) {
            return { win: true };
        }
    },
    helpText: `
		<p>
			<b>Loops</b> let you repeat a <b>block of code</b> multiple times. Here's an example loop:
		</p>

		<code-block>
			# Repeat the following block of code 5 times.
			for i in range( 5 ):
				red.walk()
				red.turn_left()
			
			# Walk backwards when finished.
			red.walk( steps = -1 )
		</code-block>

		<p>
			Python identifies <b>blocks of code</b> by using indentation (the spaces or tabs before each
			line of your code). All the lines after your "for" command which are <i>more</i> indented
			than the for statement will be repeated by the loop.
		</p>

		<p>
			The <i>unindented</i> lines (walking backwards) will <i>not</i> be repeated, and will run
			once after the loop finishes.
		</p>

		<p>
			All lines in the same <b>block</b> must have the same amount of space before them, or Python will
			get confused. For example, the following code is <b>invalid</b> because it is unclear where
			the indentation after the for ends:
		</p>

		<code-block>
			# This code is invalid because the indentation is not consistent!
			for i in range( 5 ):
			    red.walk()
			  red.turn_left()
		</code-block>
	`,
    lockedLines: 3,
    maxLines: 15,
    defaultCode: `
		from kitchen import *

		red = robots.get( 'red' )

		for i in range( 2 ):
			# Grab a drink
			red.walk_to( 3, 2, direction = EAST )
	`,
    layout: [
        'bdbbb',
        '....B',
        '.r..f',
        '....B',
    ],
    spawners: {
        d: (map, pos) => [new ServingSpot(map, pos, Direction.South)],
        b: (map, pos) => [new Bench(map, pos, Direction.South)],
        B: (map, pos) => [new Bench(map, pos, Direction.West)],
        f: (map, pos) => [new Fridge(map, pos, Drink, Direction.West)],
    }
});
